import { useState, type FormEvent } from 'react';
import { useSesion } from '../servicios/sesion.js';
import { ErrorApi } from '../servicios/api.js';
import { Marca } from '../componentes/marca.js';
import { Aviso } from '../componentes/piezas.js';

export function Acceso(): JSX.Element {
  const { iniciar, iniciarConNucleo, nucleoHabilitado } = useSesion();
  const [tenant, setTenant] = useState('depilab');
  const [email, setEmail] = useState('');
  const [contrasena, setContrasena] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function enviar(evento: FormEvent): Promise<void> {
    evento.preventDefault();
    setError(null);
    setEnviando(true);

    try {
      await iniciar(email, contrasena, tenant);
    } catch (fallo) {
      // El servidor devuelve el mismo mensaje para credenciales incorrectas,
      // cuenta inexistente y organización inválida; aquí se respeta tal cual
      // para no reintroducir en el cliente el oráculo que allá se evitó.
      setError(fallo instanceof ErrorApi ? fallo.message : 'No se pudo iniciar sesión.');
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="acceso">
      <div className="acceso-tarjeta">
        <div className="acceso-marca">
          <Marca />
        </div>
        <p className="acceso-subtitulo">Sistema de Gestión de Mantenimiento</p>

        {error ? <Aviso tono="error">{error}</Aviso> : null}

        {nucleoHabilitado ? (
          <>
            <button
              type="button"
              className="boton secundario"
              style={{ width: '100%', justifyContent: 'center' }}
              onClick={iniciarConNucleo}
            >
              Entrar con Continnua
            </button>
            <div className="acceso-separador">o</div>
          </>
        ) : null}

        <form onSubmit={(e) => void enviar(e)}>
          <div className="campo">
            <label htmlFor="tenant">Organización</label>
            <input
              id="tenant"
              value={tenant}
              onChange={(e) => setTenant(e.target.value.toLowerCase())}
              autoComplete="organization"
              required
            />
          </div>

          <div className="campo">
            <label htmlFor="email">Correo</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="username"
              required
              autoFocus
            />
          </div>

          <div className="campo">
            <label htmlFor="contrasena">Contraseña</label>
            <input
              id="contrasena"
              type="password"
              value={contrasena}
              onChange={(e) => setContrasena(e.target.value)}
              autoComplete="current-password"
              required
            />
          </div>

          <button
            type="submit"
            className="boton"
            style={{ width: '100%', justifyContent: 'center' }}
            disabled={enviando}
          >
            {enviando ? 'Ingresando…' : 'Ingresar'}
          </button>
        </form>
      </div>
    </div>
  );
}
